import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NoContent({
  className
}) {
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    viewBox: "0 0 96 96",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "96",
      height: "96",
      fill: "#fcd5d5",
      opacity: "0"
    }), /*#__PURE__*/_jsx("g", {
      transform: "translate(0.004 4.089)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M3939.612,7098.825h-36.763v-4.084h36.763Zm6.128-10.211h-20.422v-4.086h20.422Zm-30.636,0h-34.72v-4.086h34.72ZM3958,7078.4H3896.72v-4.084h6.129v-6.127h4.084v6.127h4.086v-10.209h4.085v10.209h4.087v-4.084h4.084v4.084h6.129v-16.336h-6.129a10.225,10.225,0,0,1-10.213-10.213l0-8.172a6.127,6.127,0,0,1,12.254,0v6.129h4.086V7017.13a6.126,6.126,0,1,1,12.252,0v20.422h4.086v-10.215a6.128,6.128,0,0,1,12.256,0v12.256a10.225,10.225,0,0,1-10.214,10.213h-6.127v24.508H3958Zm-24.508-4.084h4.082v-24.508a4.086,4.086,0,0,1,4.085-4.084h6.127a6.135,6.135,0,0,0,6.129-6.129v-12.254a2.043,2.043,0,1,0-4.086,0v10.211a4.089,4.089,0,0,1-4.086,4.086l-4.085,0a4.092,4.092,0,0,1-4.086-4.088V7017.13a2.041,2.041,0,0,0-4.082,0v28.594a4.087,4.087,0,0,1-4.086,4.084h-4.085a4.088,4.088,0,0,1-4.086-4.084V7039.6a2.042,2.042,0,1,0-4.085,0v8.17a6.132,6.132,0,0,0,6.127,6.127h6.129a4.091,4.091,0,0,1,4.085,4.088Zm-44.936,4.084H3862v-4.084h6.128v-6.127h4.085v6.127h4.085v-10.209h4.086v10.209h8.171Zm2.043-30.633a16.341,16.341,0,1,1,16.337-16.342,16.341,16.341,0,0,1-16.337,16.342Zm0-28.594a12.253,12.253,0,1,0,12.252,12.252,12.254,12.254,0,0,0-12.252-12.252Z",
        transform: "translate(-3862 -7011.003)",
        fill: "#333"
      })
    })]
  });
}